
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { UnpackedProductInfos } from "@/model/inventory-plan";

/**
 * 单产品
 */
@Component({
  name: "ExtraTable",
})
export default class extends Vue {
  @Prop({ required: true }) private data: UnpackedProductInfos[];
  @Prop({ required: false, default: false }) private useInvoiceMoney: boolean;
  @Prop({ required: false, default: false }) private idsList: [];
  private data_: UnpackedProductInfos[] = [];
  private options: UnpackedProductInfos[] = [];
  selection: UnpackedProductInfos[] = [];

  @Watch("data", { deep: true, immediate: true })
  private watchData() {
    this.data_ = [];
    this.data_.push(...this.data);
  }
  private changeEdit(row: UnpackedProductInfos) {
    this.$set(row, "isEdit", true);
  }
  private cancelEdit(row: UnpackedProductInfos) {
    row.isEdit = false;
    row.totalPcs = row.originTotalPcs;
  }
  private confirmEdit(row: UnpackedProductInfos) {
    this.$emit("edit-product-number", row);
    this.$set(row, "isEdit", false);
  }

  private toggleSelection(rows: UnpackedProductInfos[]) {
    if (rows) {
      this.$nextTick(() => {
        rows.forEach((row) => {
          (
            this.$refs.multipleTable as Vue & { toggleRowSelection: Function }
          ).toggleRowSelection(row);
        });
      });
    } else {
      this.$nextTick(() => {
        (
          this.$refs.multipleTable as Vue & { clearSelection: Function }
        ).clearSelection();
      });
    }
  }

  private handleSelectionChange(rows: UnpackedProductInfos[]) {
    this.selection = rows;
  }
}
